import {
  Drawer,
  Box,
  Typography,
  TextField,
  MenuItem,
  Checkbox,
  Button,
  CircularProgress
} from '@mui/material';

export default function PromotionFormModal({
  open,
  onClose,
  form,
  setForm,
  menuItems,
  selectedMenuItemId,
  setSelectedMenuItemId,
  onSubmit,
  loading
}) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 600, p: 3 }}>
        <Typography variant="h6" gutterBottom>Create Promotion</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Promotion Title"
            fullWidth
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={2}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
          <TextField
            select
            SelectProps={{
              multiple: true,
              renderValue: (selected) =>
                menuItems
                  .filter((item) => selected.includes(item._id))
                  .map((item) => item.name || item.title || 'Unnamed Item')
                  .join(', ')
            }}
            label="Item"
            fullWidth
            value={selectedMenuItemId}
            onChange={(e) => {
              const value = e.target.value;
              if (value.includes("__all__")) {
                const allIds = menuItems.map(item => item._id);
                setSelectedMenuItemId(allIds);
              } else {
                setSelectedMenuItemId(value);
              }
            }}
          >
            <MenuItem value="__all__">
              <Checkbox checked={selectedMenuItemId.length === menuItems.length} />
              Select All
            </MenuItem>
            {menuItems.map((item) => (
              <MenuItem key={item._id} value={item._id}>
                <Checkbox checked={selectedMenuItemId.includes(item._id)} />
                {item.name || item.title || 'Unnamed Item'}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Discount (%)"
            type="number"
            fullWidth
            value={form.discount}
            onChange={(e) => setForm({ ...form, discount: e.target.value })}
          />
          <TextField
            label="Start Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            fullWidth
            value={form.start}
            onChange={(e) => setForm({ ...form, start: e.target.value })}
          />
          <TextField
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            fullWidth
            value={form.end}
            onChange={(e) => setForm({ ...form, end: e.target.value })}
          />
          <TextField
            select
            label="Status"
            fullWidth
            value={form.status}
            onChange={(e) => setForm({ ...form, status: e.target.value })}
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </TextField>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              variant="contained"
              onClick={onSubmit}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            >
              {loading ? 'Saving...' : 'Save'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}